import { render, staticRenderFns } from "./settingsTableList.vue?vue&type=template&id=60995815&"
import script from "./settingsTableList.vue.ts?vue&type=script&lang=ts&"
export * from "./settingsTableList.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports